import type { ComponentProps } from 'react'
import { useFeatureFlag } from '@/scopes/common/infrastructure/feature-flags'
import { Basket as NewBasket } from './Basket'
import { BasketLegacy } from './BasketLegacy'

/**
 * @deprecated Remove this switch once BasketLegacy is deprecated, then replace with
 * `export { Basket } from './Basket'`.
 */
export function Basket(props: ComponentProps<typeof NewBasket>) {
  const isNewBasketEnabled = useFeatureFlag('MALLORCA_ENABLE_NEW_BASKET')

  return isNewBasketEnabled ? <NewBasket {...props} /> : <BasketLegacy />
}
